/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * Generated by vite-plugins/prodeng-routes.ts
 * Source: content/prodeng/2026-08-27_what-happens-when-the-air-traffic-controller-goes-on-vacation.md
 */

import { createFileRoute } from '@tanstack/react-router';
import { ProdEngArticleLayout } from '@/components/ProdEngArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/prodeng/what-happens-when-the-air-traffic-controller-goes-on-vacation.mdx';

const metadata = {
  title: "What Happens When the Air Traffic Controller Goes on Vacation",
  date: "2026-08-27",
  author: "Christian Battaglia",
  articleNumber: 7,
  seoDescription: "When the air traffic controller goes on vacation, you didn't lose a coder. You lost the map. The view cannot live in one head, a wiki, or the next AI chat.",
  linkedinUrl: "https://www.linkedin.com/pulse/what-happens-when-air-traffic-controller-goes-christian-battaglia-j1zqf",
  heroImage: "/prodeng/what-happens-when-the-air-traffic-controller-goes-on-vacation.webp",
  readTime: "14 min read",
  tags: ["product engineering","institutional memory","organizational design","leadership","AI","trust","systems thinking","software engineering"],
  published: true,
};

export const Route = createFileRoute('/prodeng/articles/what-happens-when-the-air-traffic-controller-goes-on-vacation')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title} — Product Engineering`,
    description: metadata.seoDescription || '',
    path: '/prodeng/articles/what-happens-when-the-air-traffic-controller-goes-on-vacation',
    image: '/og/prodeng/what-happens-when-the-air-traffic-controller-goes-on-vacation.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    authorName: metadata.author,
    readTime: metadata.readTime,
    tags: metadata.tags,
    section: 'Product Engineering',
  }),
});

function ArticlePage() {
  return (
    <ProdEngArticleLayout {...metadata}>
      <Content />
    </ProdEngArticleLayout>
  );
}
